import React, { Component } from 'react';
import { array, func, object } from 'prop-types';
import { withRouter } from 'react-router-dom';
import template from 'url-template';

import queryString from 'query-string';

import { connect } from 'react-redux';

import { get, has, isEmpty } from 'lodash';

import ActionBar from '../../components/ActionBar';
import ActionBarItem from '../../components/ActionBarItem';
import BOBDate from '../../components/BOBDate';
import DeviceModificationModal from '../Modals/DeviceModificationModal';
import DeviceModificationResultModal from '../Modals/DeviceModificationResultModal';
import PendingActionsModal from '../Modals/PendingActionsModal';
import RefreshNiagaraInventorySettingsModal from '../Modals/RefreshNiagaraInventorySettingsModal';

import EsmsPage from '../../components/EsmsPage';
import ElapsedTime from '../../components/ElapsedTime';
import InventoryTable from '../../components/InventoryTable';

import { isAllowed } from '../../helpers/auth';
import { Permissions } from '../../helpers/permissions';

import * as DashboardActions from '../../actions/dashboardActions';
import * as DeviceActions from '../../actions/deviceActions';
import { fetchBasAgent } from '../../actions/basAgentActions';
import { setProfile } from '../../actions/profileActions';
import {
    clearInventory,
    fetchInventory,
    selectInventory,
    triggerInventoryScan,
    updateInventory
} from '../../actions/inventoryActions';

const ExistingProfileUrl = template.parse(
    '/iothub/profiles/niagara/existing{?basAgent,company,selectedInventoryId}'
);

class InventoryPage extends Component {
    static defaultProps = {
        createDevice:         () => {},
        fetchBasAgent:        () => {},
        fetchInventory:       () => {},
        selectInventory:      () => {},
        updateInventory:      () => {},
        setProfile:           () => {},
        triggerInventoryScan: () => {}
    }
    static propTypes = {
        createDevice:         func,
        companyInfo:          object,
        currentScopes:        array,
        fetchBasAgent:        func,
        fetchInventory:       func,
        inventory:            object,
        selectedAgent:        object,
        selectInventory:      func,
        updateInventory:      func,
        setProfile:           func,
        triggerInventoryScan: func,
        updatedAt:            object
    }

    state = {
        completedDeviceCreations:         0,
        deviceCreationErrors:             [],
        disableCreateDevices:             true,
        disableUseExisting:               true,
        isSubmitting:                     false,
        pendingActions:                   {},
        pendingDeviceCreations:           0,
        selectedDeviceIds:                [],
        showPendingActionsModal:          false,
        showRefreshInventoryModal:        false,
        showNiagaraRefreshInventoryModal: false
    }

    async componentDidMount() {

        const { fetchInventory, fetchBasAgent, location } = this.props;
        const queryValues = queryString.parse(location.search);

        if (queryValues.basAgent) {
            const agent = await fetchBasAgent(queryValues.basAgent);

            await fetchInventory(agent);

            this.testLocalStorage();
        } else {
            this.redirectToBasAgents();
        }
    }

    componentDidUpdate(prevProps, prevState) {
        const { inventory } = this.props;
        const { selectedDeviceIds } = this.state;

        if (inventory !== prevProps.inventory) {
            this.testLocalStorage();
        }

        if (selectedDeviceIds !== prevState.selectedDeviceIds) {
            this.preparePendingActions();
        }
    }

    preparePendingActions = () => {
        const { inventory } = this.props;
        const { selectedDeviceIds } = this.state;

        const pendingActions = {
            actionableData: {
                title: 'To be created',
                data:  []
            },
            nonActionableData: {
                title: 'Will not be created',
                data:  []
            }
        };

        selectedDeviceIds.forEach(deviceId => {
            const device = inventory[deviceId];

            if (device && device.profileId && (!has(device, 'isCreated') || !device.isCreated)) {
                pendingActions.actionableData.data.push(device);
            } else if (device && device.isCreated) {
                const ignoredDevice = {
                    ...device,
                    reason: 'Already created.',
                    action: 'Will not be created again.'
                };

                pendingActions.nonActionableData.data.push(ignoredDevice);
            } else if (device && !device.profileId) {
                const ignoredDevice = {
                    ...device,
                    reason: 'Missing Profile.',
                    action: 'Will not be created.'
                };

                pendingActions.nonActionableData.data.push(ignoredDevice);
            }
        });

        this.setState({
            pendingActions
        });
    };

    testLocalStorage = () => {
        const { inventory, selectedAgent } = this.props;

        if (!inventory || isEmpty(inventory)) return;
        
        const rawSelectedNodes = JSON.parse(window.localStorage.getItem('niagaraInventoryTableSelectedNodes'));
        let selectedNodes = [];

        if (!isEmpty(rawSelectedNodes)) {
            const agentSelectedNodes = rawSelectedNodes.find(item => item.agentId === selectedAgent.id);

            if (agentSelectedNodes) {
                selectedNodes = agentSelectedNodes.selectedNodes;
            }
        }

        if (selectedNodes && selectedNodes.length > 0) {
            this.setState({
                disableCreateDevices: !selectedNodes.some(deviceId => (inventory[deviceId] || {}).profileId),
                disableUseExisting:   false,
                selectedDeviceIds:    [...selectedNodes]
            });
        }
    }

    redirectToBasAgents = () => {
        const { history, location } = this.props;
        const queryValues = queryString.parse(location.search);

        history.push(`/iothub/basagents?company=${queryValues.company}`);
    }

    handleIotHubRoute = () => {
        const { history, location } = this.props;
        const queryValues = queryString.parse(location.search);

        history.push(`/iothub?company=${queryValues.company}`);
    }

    handleExistingProfileRoute = () => {
        const { history, location, companyInfo } = this.props;
        const { search } = location;
        const values = new URLSearchParams(search);
        selectInventory(this.state.selectedDeviceIds[0]);
        this.state.selectedDeviceIds.forEach(id => this.props.updateInventory(id, { selected: true }));
        history.push(ExistingProfileUrl.expand({
            basAgent:            values.get('basAgent'),
            company:             companyInfo.companyId,
            selectedInventoryId: this.state.selectedDeviceIds[0]
        }));
    }

    handleSelectedAgentRoute = () => {
        const { history, location, selectedAgent } = this.props;
        const queryValues = queryString.parse(location.search);

        history.push(`/iothub/basagents/manage?company=${queryValues.company}&basAgent=${selectedAgent.id}`);
    }


    handleRefreshInventory = (isBackgroundScan, path) => {
        const { selectedAgent, triggerInventoryScan } = this.props;
        const agentId = get(selectedAgent, 'id', '');
        const configurationId = get(selectedAgent, 'driverConfiguration[0].id', '');

        triggerInventoryScan(agentId, configurationId, {}, path, isBackgroundScan);
    }

    handleCreateDevicesObjects = async () => {
        const {
            createBulkDevice,
            selectedAgent
        } = this.props;
        const agentId = get(selectedAgent, 'id', '');
        const configId = get(selectedAgent, 'driverConfiguration[0].id', '');
        const actionableDevices = get(this.state.pendingActions, 'actionableData.data', []);

        await createBulkDevice(agentId, configId, actionableDevices);

        this.handleSelectedAgentRoute();
    }

    handleDeviceSelection = selectedDeviceIds => {
        const inventory = this.props.inventory;
        let disableCreateDevices = true;
        let disableUseExisting = true;
        if (selectedDeviceIds.length) {
            disableCreateDevices =
            !selectedDeviceIds.some(
                deviceId => (inventory[deviceId] || {}).profileId
            );
            disableUseExisting = false;
        }
        this.setState({
            disableCreateDevices,
            disableUseExisting,
            selectedDeviceIds
        });
    }

    handleDeviceCreationResultClose = () => {
        this.setState({
            completedDeviceCreations: 0,
            deviceCreationErrors:     [],
            isSubmitting:             false,
            pendingDeviceCreations:   0
        });
    }

    handleToggleShowPendingActionsModal = () => {
        this.setState(state => ({
            showPendingActionsModal: !state.showPendingActionsModal
        }));
    }

    handleToggleShowRefreshInventoryModal = () => {
        this.setState(state => ({
            showRefreshInventoryModal: !state.showRefreshInventoryModal
        }));
    }

    handleToggleShowNiagaraRefreshInventoryModal = () => {
        this.setState(state => ({
            showNiagaraRefreshInventoryModal: !state.showNiagaraRefreshInventoryModal
        }));
    }

    render() {
        const {
            companyInfo,
            currentScopes,
            inventory,
            loading,
            selectedAgent,
            selectInventory,
            setWorkBookMode,
            treeCacheId,
            workbookModeEnabled,
        } = this.props;

        if (!selectedAgent) {
            return null;
        }

        const { disableCreateDevices, disableUseExisting } = this.state;
        const isFullHubAllowed = isAllowed(currentScopes, Permissions('iothubFull'));
        const hasErrors = this.state.deviceCreationErrors.length > 0;
        const driverType = selectedAgent.driverConfiguration[0].basType.toLowerCase();

        const toggleWorkbookMode = () => {
            setWorkBookMode(!workbookModeEnabled);
        };

        return (
            <EsmsPage
                parents={[companyInfo.companyName, 'BAS Agents', selectedAgent.name]}
                title="BAS Inventory"
                handlers={[this.handleIotHubRoute, this.redirectToBasAgents, this.handleSelectedAgentRoute, this.handleExistingProfileRoute]}
                subtitle={(
                    <React.Fragment>
                        <BOBDate
                            date={get(this.props.selectedAgent, 'actions.inventoryScan.timeCompleted')}
                            render={date => `Latest Inventory Date: ${date}`}
                        />
                        <p />
                        <ElapsedTime
                            dateTime={this.props.updatedAt}
                            render={(time) => `Updated ${time}`}
                        />
                    </React.Fragment>
                )}
            >
                <ActionBar>
                    <ActionBarItem
                        onClick={toggleWorkbookMode}
                        type="edit"
                    >
                        Workbook Mode
                    </ActionBarItem>
                    <ActionBarItem
                        onClick={this.handleExistingProfileRoute}
                        hidden={!isFullHubAllowed}
                        disabled={disableUseExisting}
                        type="profile"
                    >
                        Use Existing Profile
                    </ActionBarItem>
                    <ActionBarItem
                        onClick={process.env.niagaraPartialInventory ? this.handleToggleShowNiagaraRefreshInventoryModal : this.handleRefreshInventory}
                        hidden={!isFullHubAllowed}
                        type="refresh"
                    >
                        Refresh Inventory
                    </ActionBarItem>
                    <ActionBarItem
                        onClick={this.handleToggleShowPendingActionsModal}
                        hidden={!isFullHubAllowed}
                        disabled={disableCreateDevices}
                        type="save"
                    >
                        Create Devices and Objects
                    </ActionBarItem>
                </ActionBar>
                <InventoryTable
                    autoSelectDescendants={false}
                    companyInfo={companyInfo}
                    hiddenColumns={['dataType', 'sampleInterval']}
                    inventory={inventory}
                    isFullHubAllowed={isFullHubAllowed}
                    loading={loading}
                    onDeviceSelection={this.handleDeviceSelection}
                    onInventoryToggle={selectInventory}
                    treeCacheId={treeCacheId}
                    type={driverType}
                    scopes={currentScopes}
                    showProfile
                    enableLocalStorage
                />
                <DeviceModificationModal
                    completed={this.state.completedDeviceCreations}
                    modificationType="create"
                    open={this.state.isSubmitting}
                    pending={this.state.pendingDeviceCreations}
                />
                <DeviceModificationResultModal
                    errors={this.state.deviceCreationErrors}
                    modificationType="create"
                    onClose={this.handleDeviceCreationResultClose}
                    open={hasErrors}
                />
                <PendingActionsModal
                    onClose={this.handleToggleShowPendingActionsModal}
                    onConfirm={this.handleCreateDevicesObjects}
                    open={this.state.showPendingActionsModal}
                    actionData={this.state.pendingActions}
                    title="Pending Inventory Actions"
                />
                <RefreshNiagaraInventorySettingsModal 
                    onClose={this.handleToggleShowNiagaraRefreshInventoryModal}
                    open={this.state.showNiagaraRefreshInventoryModal}
                    handleRefreshInventory={this.handleRefreshInventory}
                    handleSelectedAgentRoute={this.handleSelectedAgentRoute}
                    title="Refresh Inventory Settings"
                />
            </EsmsPage>
        );
    }
}

export const mapStateToProps = ({ basAgent, ...state }) => {
    const { basAgents, selectedAgentId } = basAgent;
    const selectedAgent = basAgents[selectedAgentId];
    const { inventory, loading, treeCacheId, updatedAt } = state.inventory;

    return {
        basAgents:           basAgent.basAgents,
        selectedAgentId:     basAgent.selectedAgentId,
        companyInfo:         state.companyInfo,
        currentScopes:       state.core.currentScopes,
        devices:             state.device.devices,
        inventory,
        loading,
        selectedAgent,
        treeCacheId,
        updatedAt,
        workbookModeEnabled: state.dashboard.workbookModeEnabled
    };
};

const mapDispatchToProps = {
    clearInventory,
    fetchBasAgent,
    fetchInventory,
    selectInventory,
    updateInventory,
    setProfile,
    triggerInventoryScan,
    ...DeviceActions,
    ...DashboardActions
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(InventoryPage));
